export default function calibrate(points, { x, y }) {
  return points.map(p => ({ x: p.x + x, y: p.y + y }));
}
